import { CatalogObject } from "square";

export interface OrderItem {
  quantity: number; // NOTE: this is how many are currently in Cart (not to be added)
  product: CatalogObject;
  variation: CatalogObject;
  variantId?: string; // NOTE: used for Shipping Calculation (added in flow)
}

export interface LineItem {
  name: string;
  quantity: number;
  price: bigint;
  variationId: string;
}

/**
 * Meta pixel content id for a variation: the Square variation SKU, falling back
 * to the variation id when a variation has no SKU. This MUST mirror
 * netlify/functions/utils/meta-feed-builder.js (`id: sku`) so the ids reported
 * by the pixel match the `id` column of the exported catalog feed. Passing
 * anything else (an item id, a slug) silently surfaces in Events Manager as
 * "content IDs not matching products in your catalog" and holds catalog match
 * rate at 0%.
 */
export const getVariationSku = (variation: CatalogObject): string =>
  variation.itemVariationData?.sku?.trim() || variation.id;

/** Variation price in integer cents (repo convention; Square minor units). */
export const getVariationPriceCents = (variation: CatalogObject): number =>
  Number(variation.itemVariationData?.priceMoney?.amount ?? 0);

export const getLineItemsFromOrderItems = (
  orderItems: OrderItem[],
): LineItem[] => {
  return orderItems.map((item) => ({
    name: item.product.itemData?.name ?? "",
    quantity: item.quantity,
    price: item.variation.itemVariationData?.priceMoney?.amount ?? BigInt(0),
    variationId: item.variation.id,
  }));
};
